// creating all factories here in a separate file is needed to get tree-shaking working
import * as allFactories from '../factoriesAny';
export var all = allFactories;


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/allFactoriesAny.js
// module id = 1470
// module chunks = 0